import { render, staticRenderFns } from "./partnersEquityInfo.vue?vue&type=template&id=0664b691&scoped=true&"
import script from "./partnersEquityInfo.vue?vue&type=script&lang=js&"
export * from "./partnersEquityInfo.vue?vue&type=script&lang=js&"
import style0 from "./partnersEquityInfo.vue?vue&type=style&index=0&id=0664b691&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0664b691",
  null
  
)

export default component.exports